import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, EMPTY, Observable, take } from 'rxjs';
import { FrontendAnalyticsEventName, TRACK_EVENTS_PATH, TrackEventsBody } from '@core-http';
import { ENV_CONFIG, EnvConfig } from '../env';
import { AnalyticsEventSubType } from '../enums';

@Injectable({ providedIn: 'root' })
export class AnalyticsService {
  private readonly httpClient: HttpClient = inject(HttpClient);
  private readonly env: EnvConfig = inject(ENV_CONFIG);

  buttonClick(eventSubType: AnalyticsEventSubType, eventData?: Record<string, unknown>): void {
    this.track(FrontendAnalyticsEventName.FEButtonClick, eventSubType, eventData);
  }

  screenView(eventSubType: AnalyticsEventSubType, eventData?: Record<string, unknown>): void {
    this.track(FrontendAnalyticsEventName.FEScreenView, eventSubType, eventData);
  }

  private track(
    eventName: FrontendAnalyticsEventName,
    eventSubType: AnalyticsEventSubType,
    eventData?: Record<string, unknown>
  ): void {
    // Swagger backendu nie ma `additionalProperties`, przez co generator daje `Record<string, never>`.
    const body: TrackEventsBody = { events: [{ eventName, eventSubType, eventData: eventData as never }] };

    this.send(body).pipe(take(1)).subscribe();
  }

  private send(body: TrackEventsBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}${TRACK_EVENTS_PATH}`, body).pipe(catchError(() => EMPTY));
  }
}
